@let state = examinationsCountState$ | async;
@let count = $safeNavigationMigration(state?.data);
<div *transloco="let t" class="gap-0!" tuiTitle>
  <span class="font-medium!">
    {{ t('Examens patients') }}
  </span>
  <div tuiSubtitle [tuiSkeleton]="state.isLoading && skeletonLength">
    @if (state.hasError) {
      <span class="text-text-error-primary">{{ t('Une erreur est survenue lors du chargement des examens.') }}</span>
    } @else {
      {{
        t('{ count, plural, =0 {Aucun examen renseigné} =1 {# examen renseigné} other {# examens renseignés} }', {
          count,
        })
      }}
    }
  </div>
</div>
<tui-icon class="xl:hidden" data-testid="hint" tuiHintDirection="end" [tuiTooltip]="description" />
<pxc-action-buttons
  size="s"
  [actionButtons]="actionButtons"
  [actions]="examinationMobileActions"
  [entity]="count"
  [ngClass]="{ 'h-8 w-24': state.isLoading }"
  [tuiSkeleton]="state.isLoading" />
